import { kebabCase } from 'lodash'
import containers from './containers'
import core from './core'
import ui from './ui'

// Pages
import ProcessItems from './pages/bl/ProcessItems'

// Partials
import SeoFields from './forms/System/SeoFields'
import AddressFields from './forms/Geo/AddressFields'

// Vendors
import multiselect from 'vue-multiselect'
import draggable from 'vuedraggable'

// /**
//  * Components
//  * @type {Object}
//  */
const components = {
  ...containers,
  ...core,
  ...ui,

  // Partials
  'seo-fields': SeoFields,
  'address-fields': AddressFields,
  'process-items': ProcessItems,

  // Vendor
  multiselect,
  draggable
}

function install (Vue) {
  Object.keys(components).forEach((directive) => {
    Vue.component(kebabCase(directive), components[directive])
  })
}

export default install



// WEBPACK FOOTER //
// ./src/components/index.js